import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { PublicRoutes } from '../router/routes'

export const ProtectedRoute = ({ children }) => {
  const location = useLocation()

  if (
    localStorage.getItem('mokai-user') !== '1' &&
    location.pathname !== PublicRoutes.login
  ) {
    return <Navigate to={PublicRoutes.login} replace />
  }

  return children
}